module.exports={
    "changeData": "Change data",
    "noVisibleDataLayers": "(no visible data layers)",
    "changeGeographyLevel": "Change geography level",
    "difference": "Difference",
    "percentChange": "Percent change",
    "geographyLevel": "Geography level",
    "shadedArea": "Shaded Area",
    "bubbles": "Bubbles",
    "maskMapData": "Mask map data",
    "filterAreasByCriteria": "Filter areas by criteria",
    "mapLayers": "Map layers",
    "selectList": "Select list",
    "uploadData": "Upload data",
    "addLayer": "Add layer",
    "satelliteView": "Satellite view",
    "standardView": "Standard view",
    "streetView": "Street map view",
    "clearMask": "Clear mask",
    "basemap": "Basemap",
    "layerLibrary": "Layer library",
    "addLayers": "Add layers",
    "selectTheLatitudeAndLongitudeColumns": "Select the latitude and longitude columns from your file to put placemarks on the map.",
    "selectLayersFromLibrary": "Select layers from library",
    "dataOpacity": "Data opacity",
    "satelliteColor": "Satellite color",
    "paletteColors": "Palette colors",
    "paletteTitle": "Palette title",
    "copyColorsFromAnExistingPalette": "Copy colors from an existing palette",
    "clearFilters": "Clear filters",
    "editLayer": "Edit layer",
    "removeLayer": "Remove layer",
    "annotationHelp": "annotation help",
    "showSubGeographies": "Show sub-geographies",
    "selectGeographies": "Select geographies",
    "clickOnTheMapToSelectGeographies": "Click on the map to select geographies or",
    "addFilter": "Add criteria",
    "chooseVariable": "Choose variable",
    "allData": "All Data",
    "uploadPointData": "Upload point data",
    "dropYourCSVFileHereOr": "Drop your CSV file here, or...",
    "csvFileTooLarge": "CSV file too large. Please use file smaller than",
    "uploadPreviouslyDownloadedGeoFile": "Upload previously downloaded file containing selected geographic areas",
    "addValueAndPressEnterToApplyFilter": "Add value and press enter to apply filter",
    "matchAll": "Match all",
    "matchAny": "Match any",
    "matchNone": "Match none",
    "changeVariable": "Change variable",
    "allCategories": "All categories",
    "chooseDataVariable": "Choose data variable",
    "currentlyNotSupported": "Currently not supported for bubbles",
    "findFacilitiesByCriteria": "Find facilities by criteria",
    "dataFilter": "Data filter",
    "geoDataFilter": "Geo data filter",
    "change": "Change",
    "minimize": "Minimize",
    "moreVisualizationOptions": "More visualization options",
    "chooseColumnsToPositionYourPlacemarks": "Choose columns to position your placemarks",
    "loadingUserDataLayers": "Loading user data layers...",
    "previousUploads": "Previous uploads",
    "fullAddressIsInASingleColumn": "Full address is in a single column",
    "geocoderCurrentlyOnlyWorksWithTheUSAddresses": "Geocoder currently only works with the United States addresses",
    "geocodingLoaderText": "Geocoding... This could take a while",
    "sampleAddressesToGeocode": "Sample addresses to geocode",
    "loadingLayerData": "Loading layer data",
    "noResultsFor": "No results for",
    "noVariables": "No variables available",
    "resetMap": "Reset map",
    "resetMapDescription": "This removes all added layers and restores the default map.",
    "resetSavedMapDescription": "This undoes your unsaved changes to this map.",
    "resetMapTo": "Resets to",
    "resetMapToDefault": "the default map",
    "resetMapToSaved": "{title}, as last saved",
    "resetMapLayers": "Layers: {layers}",
    "resetMapNoLayers": "No added layers"
}
